import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  // ModalCloseButton,
  ModalBody,
  ModalFooter,
  NumberInput,
  NumberInputField,
  // Image,
} from '@chakra-ui/react';

export const ModalInput = ({ title, body, isOpen, onClose, onCancel, children }) => {
  const [value, setValue] = useState();

  const hasCancelButton = !!onCancel;

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          {body}
          <NumberInput
            my={5}
            min={0}
            value={value}
            onChange={(valueString) => setValue(valueString)}
          >
            <NumberInputField />
          </NumberInput>
          {children}
        </ModalBody>
        <ModalFooter>
          {hasCancelButton && (
            <Button minWidth={125} size={'lg'} mr={3} onClick={onCancel}>
              Annulla
            </Button>
          )}
          <Button
            minWidth={125}
            size={'lg'}
            mr={3}
            isDisabled={!value}
            onClick={() => {
              onClose(value);
              setValue();
            }}
          >
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
